import {
  LayoutGrid,
  Activity,
  Bell,
  ClipboardPlus,
  AlertTriangle,
  Truck,
  Users,
  Book,
  BarChart3,
  Settings,
  type LucideIcon,
} from 'lucide-react';

export type NavBadge =
  | { kind: 'dot'; color: string }
  | { kind: 'pill'; text: string; className: string };

export interface NavItemDef {
  key: string;
  label: string;
  icon: LucideIcon;
  path: string;
  /** extra route prefixes that also mark this item active (group match) */
  match?: string[];
  badge?: NavBadge;
}

export interface NavSectionDef {
  header: string;
  items: NavItemDef[];
}

export const NAV_SECTIONS: NavSectionDef[] = [
  {
    header: 'Inicio',
    items: [
      { key: 'dashboard', label: 'Cuadro de mando', icon: LayoutGrid, path: '/dashboard' },
    ],
  },
  {
    header: 'Operativa',
    items: [
      {
        key: 'operativa',
        label: 'Hub operativo',
        icon: Activity,
        path: '/operativa',
        badge: { kind: 'dot', color: 'var(--op-bad)' },
      },
      {
        key: 'avisos',
        label: 'Avisos',
        icon: Bell,
        path: '/avisos',
        match: ['/avisos', '/altaAviso'],
        badge: { kind: 'pill', text: '3', className: 'text-[#cfd8e6] bg-[#22304a]' },
      },
    ],
  },
  {
    header: 'Gestión',
    items: [
      { key: 'partes', label: 'Asistencias', icon: ClipboardPlus, path: '/asistencias' },
      { key: 'accidentes', label: 'Accidentes', icon: AlertTriangle, path: '/accidentes' },
      {
        key: 'vehiculos',
        label: 'Vehículos',
        icon: Truck,
        path: '/vehiculos',
        match: ['/vehiculos'],
        badge: {
          kind: 'pill',
          text: '1',
          className: 'text-[#ffb02e] bg-[rgba(255,176,46,.2)]',
        },
      },
    ],
  },
  {
    header: 'Sistema',
    items: [
      { key: 'usuarios', label: 'Usuarios', icon: Users, path: '/usuarios' },
      { key: 'maestros', label: 'Catálogos', icon: Book, path: '/catalogos' },
      { key: 'estadistica', label: 'Estadísticas', icon: BarChart3, path: '/estadisticas' },
      { key: 'config', label: 'Configuración', icon: Settings, path: '/configuracion' },
    ],
  },
];
